import { useEffect } from 'react';

import pixel from '@services/pixel';
import { getPlanValue } from '@utils/money';

export function useCheckoutAnalytics(plan: any, currency: string) {
  useEffect(() => {
    const pageViewData = {
      plan,
      value: getPlanValue(plan),
      currency,
      pageType: 'checkout',
      url: window.location.href,
    };

    pixel.setUserData(pageViewData);
    pixel.dispatchEvent(pixel.events.page_view, pageViewData);
  }, [currency, plan]);
}

